import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { Toast } from '../types/models';
import { CUSTOMER_LOCATION_QUERY_KEY } from '../queryHooks/customerLocation.ts';
const useDeactivateLocations =  (
  options?: UseMutationOptions<
    Toast | null,
    unknown,
    number[]
  >
) => {
  const queryClient = useQueryClient();
  return useMutation<Toast | null, unknown, number[]>({
    mutationKey: [endpoints.customerLocation.update.deactivate.many.by.id()],
    mutationFn: api.customerLocation.update.deactivate.many.by.id,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CUSTOMER_LOCATION_QUERY_KEY,
          endpoints.customerLocation.read.all.hydrated.by.userId(),],
      });
    },
    ...options,
  });
}

const useReactivateCustomerLocations = (
  options?: UseMutationOptions<
    Toast | null,
    unknown,
    number
  >,
) => {
  const queryClient = useQueryClient();
  return useMutation<Toast | null, unknown, number>({
    mutationKey: [endpoints.customerLocation.read.all.hydrated.by.userId()],
    mutationFn: api.customerLocation.update.activate.one.by.id,
    onSuccess: async (response) => {
      await queryClient.invalidateQueries({
        queryKey: [CUSTOMER_LOCATION_QUERY_KEY,
          endpoints.customerLocation.read.all.hydrated.by.userId(),],
      });
    },
    ...options
  });
}

const locationMutationHooks = {
  useDeactivateLocations,
  useReactivateCustomerLocations,
}

export default locationMutationHooks;